import React from 'react';

// Catches the mapbox-gl `_updateTerrain` -> undefined.get crash that fires
// during Source cleanup (mapbox-gl-js#12352, fixed in 3.7+; we're on 3.1).
// Without this, the whole React tree above the Map unmounts and the user
// sees a black screen with no way back.
export class MapErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Map crashed:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          height: '100%', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 12,
          background: '#0f172a', color: '#e2e8f0', padding: 24, textAlign: 'center',
        }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>The map crashed.</div>
          <div style={{ fontSize: 13, color: '#94a3b8', maxWidth: 480 }}>
            {String(this.state.error?.message || this.state.error)}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8, padding: '8px 16px', borderRadius: 6, border: 'none',
              background: '#22d3ee', color: '#0f172a', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
